import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function About() {
  return (
    <section id="about" className="jh-section bg-white relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        {/* Image column */}
        <div className="relative">
          <div className="jh-shape-circle mx-auto w-[300px] h-[300px] sm:w-[380px] sm:h-[380px] md:w-[520px] md:h-[520px] relative">
            <img
              src="https://images.pexels.com/photos/5430213/pexels-photo-5430213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Ghanaian healthcare professionals"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Floating badge */}
          <div className="absolute -left-2 sm:-left-4 md:left-4 top-6 sm:top-10 md:top-24 w-[130px] h-[130px] sm:w-[150px] sm:h-[150px] md:w-[170px] md:h-[170px] rounded-full bg-white shadow-xl border border-black/5 flex flex-col items-center justify-center text-center">
            <span className="text-[13px] font-medium text-[#E11D2E]">Licensed</span>
            <span className="font-display font-extrabold text-[22px] leading-none text-[#0e1421] mt-1">PEA/819</span>
            <span className="text-[11px] text-gray-500 mt-1 px-4">Government of Ghana</span>
          </div>
          {/* Red half circle accent */}
          <div className="absolute -bottom-4 right-4 w-32 h-32 rounded-full bg-[#E11D2E] hidden md:block" />
        </div>

        {/* Content column */}
        <div>
          <span className="jh-eyebrow">About John Herbert Limited</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4 mb-6">
            Ethical International Recruitment from Ghana
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {[
              'Healthcare & Aged Care Recruitment',
              'Skilled Trades & Industry Talent',
            ].map((t) => (
              <div
                key={t}
                className="flex items-start gap-3 border border-black/10 rounded-md p-4"
              >
                <CheckCircle2 className="text-[#E11D2E] flex-shrink-0 mt-0.5" size={22} />
                <span className="font-semibold text-[15px] text-[#0e1421] leading-snug">
                  {t}
                </span>
              </div>
            ))}
          </div>

          <p className="font-semibold text-[17px] text-[#0e1421] mb-5 leading-relaxed">
            Connecting employers worldwide with highly qualified, work-ready
            Ghanaian professionals — lawfully, transparently and ethically.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            John Herbert Limited is a Government of Ghana-licensed Private
            Employment Agency (Licence No. PEA/819), authorised under the
            Labour Act, 2003 (Act 651). We recruit, prepare and deploy qualified
            Ghanaian professionals and skilled workers for employment
            opportunities both within Ghana and internationally through
            Ghana’s Work Abroad Programme.
          </p>

          <a href="#services" className="jh-btn-dark">
            Explore Our Services
          </a>
        </div>
      </div>
    </section>
  );
}
